import React, { useState, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  Alert,
  StyleSheet,
  Modal,
  ScrollView,
  TextInput,
  ActivityIndicator,
} from "react-native";

import { useTranslation } from "react-i18next";

import Block from "../Firestore/Block";
import Workout from "../Firestore/Workout";
import Exercise from "../Firestore/Exercise";
import Serie from "../Firestore/Serie";
import Attribute from "../Firestore/Attribute";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";

import { observer, Observer } from "mobx-react";

import { Octicons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { MaterialIcons } from "@expo/vector-icons";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../_layout";
import IconEmptyView from "../Components/IconEmptyView";
import CustomActivityIndicator from "../Components/CustomActivityIndicator";
import ClientWeekStatusText from "../Components/ClientWeekStatusText";
import { useModalKeyboardShortcuts } from "../platform/guards/modalKeyboardShortcuts";
import {
  filterBlockCopyEligibleClients,
  isBlockCopyEligibleClient,
} from "../invitations/invitedClientUiGuards";

const CopyBlockToClient = ({ isVisible, onClose, block }) => {
  const { t } = useTranslation();

  const [selectedClients, setSelectedClients] = useState([]);

  const [copyEntireBlock, setCopyEntireBlock] = useState(false);

  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [notBlocked, setNotBlocked] = useState([]);

  const resolveCopyTargetClients = () => {
    const filteredClients = block?.client?.coach?.getFilteredClients?.() ?? [];

    return filterBlockCopyEligibleClients(filteredClients).filter(
      (client) => client.id !== block?.client?.id
    );
  };

  function toggleVariable() {
    setNotBlocked();

    setTimeout(() => {
      setNotBlocked(true);
      onClose();
    }, 2500); // 2000 milliseconds = 2 seconds
  }

  const SearchBar = () => {
    const [keyword, setKeyword] = useState("");
    const onChangeText = (text) => {
      setKeyword(text);
      block.client.coach.setSearchTerm(text);
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
          paddingHorizontal: 20,
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        <View
          style={[
            styles.searchBar,
            {
              backgroundColor: "transparent",
              // width: "50%",
              flex: 1,
              borderWidth: 0.2,
              // borderColor: Colors.grayColor,

              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Octicons name="search" size={20} color={Colors.grayColor} />
          <TextInput
            value={keyword}
            onChangeText={onChangeText}
            style={[
              styles.textInputStyle,
              { color: Colors.blackColor, outline: "none", width: "100%" },
            ]}
            placeholder={t("searchClient-string")}
            placeholderTextColor={Colors.grayColor}
            disabled={!notBlocked}
            maxLength={100}
          />
        </View>
        <Buttons bool={false} />
        <Buttons bool={true} />
      </View>
    );
  };

  const ClientRow = observer(({ client, isLastRow }) => {
    const isSelected = selectedClients.includes(client.id);
    const select = () => {
      if (isSelected) {
        // Append the client's userId to the array
        setSelectedClients((prevSelectedClients) =>
          prevSelectedClients.filter((id) => id !== client.id)
        );
      } else {
        // Remove the client's userId from the array
        setSelectedClients((prevSelectedClients) => [
          ...prevSelectedClients,
          client.id,
        ]);
      }
      block.client.coach.setSearchTerm("");
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
      <View
        style={{
          flexDirection: "row",
          flex: 1,
          //marginTop: 20,
          padding: 5,
          paddingHorizontal: 16,

          alignItems: "center",
          // borderRadius: 12,
          backgroundColor: isSelected ? Colors.bubbleColor : "transparent",
          paddingVertical: 8,

          borderBottomLeftRadius: isLastRow ? 14 : 0,
          borderBottomRightRadius: isLastRow ? 14 : 0,

          opacity: isHovered ? 0.9 : 1,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TouchableOpacity
          onPress={select}
          style={{ flex: 1 }}
          disabled={!notBlocked}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <View
              style={{
                alignItems: "flex-start",
                // marginHorizontal: 10,
                width: "100%",
                paddingLeft: isHovered ? 5 : 0,
              }}
            >
              <Text
                style={{
                  color: isSelected ? Colors.whiteColor : Colors.blackColor,
                  fontSize: 16,
                  fontWeight: isHovered ? "600" : "normal",
                }}
              >
                {client.nameForCoach} {client.surnameForCoach}
              </Text>
              <ClientWeekStatusText
                client={client}
                style={{
                  color: isSelected ? Colors.lightGrayColor : Colors.grayColor,
                  fontSize: 12,
                  marginTop: 2,
                }}
                showColorForUnprepared={isSelected ? false : true}
              />
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          />
          <View
            style={{
              //height: selectedClientName === client.name ? 2 : 1,
              backgroundColor: Colors.grayColor,
              // marginTop: 5,
            }}
          />
        </TouchableOpacity>
      </View>
    );
  });

  const Cancel = () => {
    block.client.coach.setSearchTerm("");
    onClose();
  };
  const canSave = selectedClients.length > 0;

  const handleSave = async () => {
    if (!canSave) {
      return;
    }

    toggleVariable();

    try {
      const copyPromises = selectedClients.map(async (clientId) => {
        const clientObject = block.client.coach.clients.find(
          (cli) => cli.id === clientId
        );
        const isSourceClient = clientId === block?.client?.id;
        const isEligibleCopyTarget = isBlockCopyEligibleClient(clientObject);

        if (!clientObject || isSourceClient || !isEligibleCopyTarget) {
          console.warn(
            `Skipping stale or ineligible block copy target with ID: ${clientId}`
          );
          return;
        }

        if (copyEntireBlock) {
          await clientObject.copyBlockToClient(t, block, true);
        } else {
          await clientObject.copyBlockToClient(t, block);
        }
      });

      if (copyPromises.length === 0) {
        return;
      }

      await Promise.all(copyPromises);
    } catch (error) {
      console.error("Error copying block to clients:", error);
    }
  };

  useModalKeyboardShortcuts({
    isVisible,
    onConfirm: handleSave,
    onCancel: Cancel,
    isConfirmEnabled: canSave,
    allowEnterOnSingleLineInput: false,
    isBlocked: () => !notBlocked,
  });

  const Buttons = ({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";

    const [isHovered, setIsHovered] = useState(false);

    // return (
    //   <TouchableOpacity onPress={bool ? Save : Cancel} disabled={!notBlocked}>
    //     <View
    //       style={{
    //         // marginHorizontal: 20,
    //         backgroundColor: bool ? Colors.bubbleColor : Colors.whiteColor,
    //         borderRadius: 14,
    //         borderWidth: 1,
    //         justifyContent: "center",
    //         borderColor: bool ? Colors.bubbleColor : "red",
    //         width: 80,
    //         height: 35,
    //         justifyContent: "center",
    //         alignItems: "center",
    //         opacity: bool ? (canAdd ? 1 : 0.5) : 0.7,
    //         marginHorizontal: !bool && 10,
    //       }}
    //     >
    //       {!notBlocked && bool ? (
    //          <CustomActivityIndicator large={false} white={true}/>
    //       ) : (
    //         <Text
    //           style={{
    //             textAlignVertical: "center",
    //             textAlign: "center",
    //             color: bool ? Colors.whiteColor : "red",
    //           }}
    //         >
    //           {t(text)}
    //         </Text>
    //       )}
    //     </View>
    //   </TouchableOpacity>
    // );

    return bool ? (
      <TouchableOpacity
        onPress={handleSave}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={!notBlocked}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.8 : canSave ? 1 : 0.5,
          }}
        >
          {/* <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text> */}
          {!notBlocked ? (
            <CustomActivityIndicator large={false} white={true} />
          ) : (
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: Colors.whiteColor,
              }}
            >
              {t(text)}
            </Text>
          )}
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={Cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={!notBlocked}
      >
        <View
          style={{
            marginHorizontal: 10,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const EntireBlockCheck = () => {
    const [isCheckHovered, setIsCheckHovered] = useState(false);

    return (
      <View
        style={{
          flexDirection: "row",
          paddingHorizontal: 20,
          alignItems: "center",
        }}
      >
        <TouchableOpacity
          onPress={() => setCopyEntireBlock(!copyEntireBlock)}
          style={{ marginRight: 5 }}
          onMouseEnter={() => !isMobile && setIsCheckHovered(true)}
          onMouseLeave={() => setIsCheckHovered(false)}
        >
          <MaterialIcons
            name={copyEntireBlock ? "check-box" : "check-box-outline-blank"}
            size={20}
            color={Colors.bubbleColor}
            style={{ opacity: isCheckHovered && copyEntireBlock ? 0.8 : 1 }}
          />
          {isCheckHovered && !copyEntireBlock && (
            <MaterialIcons
              name="check"
              size={14}
              color={Colors.bubbleColor}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: [{ translateX: -7 }, { translateY: -7 }],
                opacity: 0.8,
              }}
            />
          )}
        </TouchableOpacity>

        <Text>{t("copyEntireBlock-string")}</Text>
      </View>
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={notBlocked && onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={Cancel}
          style={GlobalStyles.touchableBackground}
          disabled={!notBlocked}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{
            position: "absolute",
            // height: "100%",
            // width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                maxWidth: screenSize === "small" ? 360 : 450,
                width: "90%",
                maxHeight: screenSize === "small" ? 450 : 600,
                alignSelf: "center",
                // height: "100%",
              },
            ]}
          >
            <SearchBar />
            <EntireBlockCheck />
            <View
              style={{
                marginTop: 10,
                width: "100%",
              }}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontWeight: "500",
                  marginLeft: 15,
                  marginBottom: 4,
                }}
              >
                {t("athletes-string")}
              </Text>
              <View
                style={{
                  height: 0.5,

                  // backgroundColor: "rgba(255, 255, 255, 0.2)",
                  backgroundColor: Colors.grayColor,
                }}
              />
            </View>
            <Observer>
              {() => {
                const copyTargetClients = resolveCopyTargetClients();

                return (
                  <ScrollView
                    style={{
                      marginHorizontal: 0,
                      marginBottom: 0,
                      borderBottomLeftRadius: 15,
                      borderBottomRightRadius: 15,
                    }}
                    showsVerticalScrollIndicator={false}
                  >
                    {copyTargetClients.length > 0 ? (
                      <>
                        {copyTargetClients.map((client, index) => (
                          <View key={client.id}>
                            <ClientRow
                              client={client}
                              isLastRow={index === copyTargetClients.length - 1}
                            />
                            {index < copyTargetClients.length - 1 && (
                              <View
                                style={{
                                  height: 0.5,
                                  // backgroundColor: "rgba(255, 255, 255, 0.2)",
                                  backgroundColor: Colors.grayColor,
                                  // marginHorizontal: 20,
                                }}
                              />
                            )}
                          </View>
                        ))}
                      </>
                    ) : (
                      <>
                        <IconEmptyView
                          iconLibrary={"Ionicons"}
                          mainText={"emptyClientsTitle-string"}
                          subText={"noAthletesFoundText-string"}
                          iconName={"people-outline"}
                          marginTop={40}
                          marginBottom={8}
                        />
                      </>
                    )}
                  </ScrollView>
                );
              }}
            </Observer>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    // width: 600,
    // maxHeight: screenHeight * 0.5,
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
  },
  saveButtonStyle: {
    backgroundColor: "#2196F3",
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    width: "100%",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 16,
  },
  textInputStyle: {
    // height: 40,
    // marginBottom: 20,
    // marginHorizontal: 10,
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 14,
    // backgroundColor: "red",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    // marginHorizontal: 10,
    paddingHorizontal: 10,
    borderRadius: 12,
    height: 40,
    // backgroundColor: "white",
  },
});

export default CopyBlockToClient;
